import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { forwardRef, useMemo } from 'react';
import { composeRenderProps, Checkbox as Checkbox$1 } from 'react-aria-components';
import { CheckSVG } from './check-svg.esm.js';
import { CheckboxGroup } from './checkbox-group.esm.js';
import { useComponentTheme } from '../../theme/theme.context.esm.js';
import Text from '../text/text.esm.js';
import '../text/heading.esm.js';
import '../text/text-container.esm.js';

var _excluded = ["className", "testId", "ellipsis", "checkboxAlignment", "size", "children"];
function Check(props) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    _props$size = props.size,
    size = _props$size === void 0 ? 'inherit' : _props$size,
    isIndeterminate = props.isIndeterminate,
    renderProps = props.renderProps;
  var theme = useComponentTheme('Checkbox');
  var classes = useMemo(function () {
    return theme.check(_objectSpread2({
      variant: variant,
      size: size
    }, renderProps));
  }, [variant, size, renderProps, theme]);
  return /*#__PURE__*/React.createElement("div", {
    className: "csg-tw-check ".concat(classes)
  }, renderProps.isSelected || variant === 'circle' ? /*#__PURE__*/React.createElement(CheckSVG, {
    isIndeterminate: isIndeterminate
  }) : undefined);
}
var PrivateCheckbox = /*#__PURE__*/forwardRef(function CardRoot(props, ref) {
  var _props$className = props.className,
    _className = _props$className === void 0 ? '' : _props$className,
    testId = props.testId,
    ellipsis = props.ellipsis,
    _props$checkboxAlignm = props.checkboxAlignment,
    checkboxAlignment = _props$checkboxAlignm === void 0 ? 'center' : _props$checkboxAlignm,
    size = props.size,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var theme = useComponentTheme('Checkbox');
  var classes = useMemo(function () {
    return composeRenderProps(_className, function (className, renderProps) {
      var classes = theme.base(_objectSpread2(_objectSpread2({}, renderProps), {}, {
        size: size,
        checkboxAlignment: checkboxAlignment,
        className: className
      }));
      return "csg-tw-checkbox ".concat(classes);
    });
  }, [_className, theme, size, checkboxAlignment]);
  return /*#__PURE__*/React.createElement(Checkbox$1, _extends({
    ref: ref,
    className: classes,
    "data-testid": testId
  }, rest), function (renderProps) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Check, _extends({
      size: size,
      checkboxAlignment: checkboxAlignment,
      renderProps: renderProps
    }, rest)), typeof children === 'string' ? /*#__PURE__*/React.createElement(Text, {
      ellipsis: ellipsis
    }, children) : children);
  });
});
var Checkbox = Object.assign(PrivateCheckbox, {
  Group: CheckboxGroup
});
Checkbox.displayName = 'Checkbox';

export { Checkbox as default };
//# sourceMappingURL=checkbox.esm.js.map
